import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAtxdZqalKiuckuPiT2N9nRknF8cta8Y0Y",
  authDomain: "smart-campus-africa.firebaseapp.com",
  projectId: "smart-campus-africa",
  storageBucket: "smart-campus-africa.firebasestorage.app",
  messagingSenderId: "986317221745",
  appId: "1:986317221745:web:5f98b9a779b0c2364fd0d0",
  measurementId: "G-56BQB76V6T"
};

const app = initializeApp(firebaseConfig);
const embeddedApp = initializeApp(firebaseConfig, 'smartcampus-embedded-signups');

export const auth = getAuth(app);
export const embeddedAuth = getAuth(embeddedApp);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
export default app;
